import styled from 'styled-components'

export const ContentArea = styled.div`
  width: 100%;
`
